module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_int_01_6DC79_1SD_HIK.e73a9a75.jpg";